import MODULE_REGISTRY from "@/modules";
import { HomeFilled } from "@ant-design/icons";
import { useAppSelector } from "@redux/store";
import { IConfig } from "@type/router";
import { getTreeLeaf } from "@utils/common";
import { BreadcrumbWrapper } from "@views/Breadcrumb/styled";
import { ItemType } from "antd/es/breadcrumb/Breadcrumb";
import { TFunction } from "i18next";
import { useTranslation } from "react-i18next";
import { Link, useLocation } from "react-router-dom";

interface BreadcrumbItemType extends ItemType {
  isClickable?: boolean;
}

function itemRender(route: ItemType, params: any, routes: ItemType[], paths: string[]) {
  const isLast = route?.path === routes[routes.length - 1]?.path;
  const breadcrumbRoute = route as BreadcrumbItemType;
  const isClickable = breadcrumbRoute.isClickable !== false;

  if (isLast || !isClickable) {
    return <span>{route.title}</span>;
  }
  return <Link to={`/${paths.join("/")}`}>{route.title}</Link>;
}
function getBreadcrumbItems(menuConfig: IConfig[], currentPath: string, t: TFunction<"translation", undefined>): BreadcrumbItemType[] {
  const data = getTreeLeaf(menuConfig, "path", currentPath);
  if (!data) {
    return [];
  }
  const Home: BreadcrumbItemType[] = [
    {
      path: "",
      title: <HomeFilled />,
      key: "Home",
      isClickable: true,
    },
  ];
  const parent: BreadcrumbItemType[] = data.parentKey.map(e => {
    // Parent is clickable only if it has a component in the registry or a redirect
    const isClickable = MODULE_REGISTRY[e.key]?.component != null || e.redirect != null;
    return { title: t(e.label), key: e.key, path: e.path, isClickable };
  });
  const leaf: BreadcrumbItemType[] = [{ title: t(data.leaf.label), key: data.leaf.key, path: data.leaf.path, isClickable: true }];
  return [...Home, ...parent, ...leaf];
}
function MainBreadcrumb() {
  const { t } = useTranslation();
  const location = useLocation();
  const routerData = useAppSelector(state => state.router);
  const menuConfig = routerData.menuConfig[0].children ?? [];

  return <BreadcrumbWrapper items={getBreadcrumbItems(menuConfig, location.pathname, t)} itemRender={itemRender} />;
}
export default MainBreadcrumb;
